import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class NebulaPaginatorIntl extends MatPaginatorIntl {

  constructor(private translate: TranslateService) {
    super();
    this.nextPageLabel = this.translate.instant('Common_NextPage');
    this.previousPageLabel = this.translate.instant('Common_PreviousPage');
  }
  getRangeLabel = (page: number, pageSize: number, length: number) => {
    return this.translate.instant('Common_Page', { page: (page + 1) });
  }
}

export function NEBULA_PAGINATOR_INTL_PROVIDER_FACTORY(translate: TranslateService) {
  return new NebulaPaginatorIntl(translate);
}

export const NEBULA_PAGINATOR_INTL_PROVIDER = {
  provide: MatPaginatorIntl,
  deps: [TranslateService],
  useFactory: NEBULA_PAGINATOR_INTL_PROVIDER_FACTORY
};
